<template>
	<div>
		<div class="detailsBox">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="号段管理" name="1"><themRoughlyManagement v-if="activeName == 1"></themRoughlyManagement></el-tab-pane>
				<el-tab-pane label="抽样任务" name="2"><LotteryTask v-if="activeName == 2"></LotteryTask></el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
import themRoughlyManagement from '@/page/telecommunications/sampling/themRoughlyManagement.vue';
import LotteryTask from '@/page/telecommunications/sampling/LotteryTask.vue';
export default {
	components: {
		themRoughlyManagement,
		LotteryTask
	},
	data() {
		return {
			activeName: '1'
		};
	},
	methods: {
		handleClick(tab, event) {
			console.log(tab, event);
		},
	}
};
</script>
<style scoped lang="scss">
.details_header {
	height: 60px;
	line-height: 60px;
	text-align: center;
	background-color: #0080ff;
	margin: auto;
	display: flex;
	justify-content: space-between;
	span {
		// color: #333333;
		color: #fff;
		font-size: 16px;
		padding: 0px 30px;
	}
	margin-bottom: 20px;
	cursor: pointer;
}
.detailsBox {
	padding: 20px;
}
</style>
